// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentButton__root___3dV3k"};